import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { timeEntriesAPI } from '../services/api';
import { TimeEntry } from '../types';
import { formatDate, formatDurationMinutes } from '../utils';

const formatDateTime = (value?: string) => {
  if (!value) {
    return '—';
  }

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return formatDate(value);
  }

  return date.toLocaleString(undefined, {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  });
};

const DeletedEntriesPage: React.FC = () => {
  const [entries, setEntries] = useState<TimeEntry[]>([]);
  const [loading, setLoading] = useState(true);
  const [totalCount, setTotalCount] = useState(0);

  useEffect(() => {
    setLoading(true);
    timeEntriesAPI.getDeletedEntries({ skip: 0, take: 500 })
      .then(data => {
        setEntries(data.items);
        setTotalCount(data.totalCount);
      })
      .catch(() => toast.error('Deleted entries could not be loaded'))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="fade-in">
      <div className="page-header">
        <div>
          <h1>Deleted entries</h1>
          <p>{loading ? 'Loading deleted entries...' : `${totalCount} deleted records`}</p>
        </div>
      </div>

      <section className="card">
        <div className="card-header">
          <h5 className="card-title">Deleted entry list</h5>
        </div>
        <div className="card-body">
          <div className="table-responsive">
            <table className="table table-hover">
              <thead>
                <tr>
                  <th>Deleted date</th>
                  <th>Work date</th>
                  <th>Member</th>
                  <th>Client</th>
                  <th>Project</th>
                  <th>Task</th>
                  <th>Description</th>
                  <th>Hours</th>
                  <th>Deleted by</th>
                </tr>
              </thead>
              <tbody>
                {entries.map(entry => (
                  <tr key={entry.id}>
                    <td>{formatDateTime(entry.deletedDate)}</td>
                    <td>{formatDate(entry.workDate)}</td>
                    <td>{entry.timeProfileName}</td>
                    <td>{entry.customerTitle || 'Unassigned'}</td>
                    <td>{entry.projectTitle || 'Internal'}</td>
                    <td>{entry.projectTaskTitle || '—'}</td>
                    <td>{entry.description || '—'}</td>
                    <td>{formatDurationMinutes(entry.durationMinutes)}</td>
                    <td>{entry.updatedByUserEmail || '—'}</td>
                  </tr>
                ))}
                {!loading && entries.length === 0 && (
                  <tr>
                    <td colSpan={9}>
                      <div className="empty-state compact">No deleted entries</div>
                    </td>
                  </tr>
                )}
                {loading && (
                  <tr>
                    <td colSpan={9}>
                      <div className="empty-state compact">Loading...</div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </section>
    </div>
  );
};

export default DeletedEntriesPage;
